export default __webpack_public_path__ + "static/media/Banner_Inicio.ba017ec0.png";